module.exports = __webpack_public_path__ + "img/calendar.7369e781.svg";